import { useMutation } from "@tanstack/react-query";
import { Alert, Button, Col, Divider, List, notification, Popconfirm, Row, Typography } from "antd";
import React from "react";
import { DocumentoService } from "../Services/Domain/Documentos/DocumentoService";
import { CopyOutlined } from "@ant-design/icons";

interface GestaoDeGUIDsProps<T> {
  guids: string[];
  title?: React.ReactElement,
  adicionar: () => Promise<T | undefined>;
  depoisDeDesativar?: () => any;
  depoisDeAdicionar?: (result?: T) => any;

  listProps?: React.ComponentProps<typeof List>;
  gerarBtnProps?: React.ComponentProps<typeof Button>;
  ocultarSeVazio?: boolean
  ocultarAviso?: boolean
}

export const GestaoDeGUIDs = <T,>(props: GestaoDeGUIDsProps<T>) => {

    const { guids } = props;

    const desativarGUIDMutation = useMutation({
        mutationKey: ["DocumentoService.desativarRecursoCompartilhado"],
        mutationFn: (d: {guid: string}) => DocumentoService.desativarRecursoCompartilhado(d.guid),
        onSuccess: () => props.depoisDeDesativar?.()
    })

    const adicionarGUIDMutation = useMutation({
        mutationKey: [],
        mutationFn: props.adicionar,
        onSuccess: (a, b, c) => props.depoisDeAdicionar?.(a)
    })

    const copiarParaOClipboard = (id: string) => {
        notification.open({
            message: "Link copiado.",
            placement: "top"
        })
        navigator.clipboard.writeText(id)
    }

    const comURL = (id: string) => `${window.location.host}/docs/${id}`

    return (
        <React.Fragment>
            {props.ocultarAviso !== true && props.guids.length > 0 && (
                <Alert
                    closable
                    style={{ marginBottom: "1em" }}
                    type="warning"
                    description={
                        <>
                            Qualquer pessoa com acesso a um dos links poderá acessar o recurso.
                            <br /> Você pode revogar um link a qualquer momento clicando em "excluir".
                        </>
                    }
                />
            )}
            <Row>
                <Col xs={24} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <Typography.Title level={5} style={{ margin: 0 }}>
                        {props.title}
                    </Typography.Title>
                    <Button style={{ marginLeft: "auto" }} {...props.gerarBtnProps} onClick={() => adicionarGUIDMutation.mutate()}>
                        Gerar novo link
                    </Button>
                </Col>
                <Col xs={24} style={{ display: props.ocultarSeVazio === true && guids.length == 0 ? "none" : "unset" }}>
                    <List
                        {...props.listProps}
                        dataSource={guids.map((id) => [id, comURL(id)])}
                        renderItem={([id, link]) => {
                            return (
                                <List.Item
                                    actions={[
                                        <Popconfirm title={"Tem certeza?"} onConfirm={() => desativarGUIDMutation.mutate({ guid: id })}>
                                            <Button type="link" disabled={desativarGUIDMutation.isPending}>
                                                Excluir
                                            </Button>
                                        </Popconfirm>,

                                        <Button type="link" onClick={() => copiarParaOClipboard(link)} icon={<CopyOutlined />}>
                                            Copiar
                                        </Button>,
                                    ]}
                                >
                                    <a href={"/docs/" + id} style={{textWrap: "wrap", overflowWrap: "anywhere"}} target="_blank">
                                        {link}
                                    </a>
                                </List.Item>
                            );
                        }}
                    />
                </Col>
            </Row>
        </React.Fragment>
    );
};
